import gql from 'graphql-tag';

export const CreateAutomationRuleFromTemplateMutation = gql`
	mutation experimentalCreateAutomationRuleFromTemplateMutation(
		$templateId: String!
		$cloudId: String!
		$automationStack: String!
		$spaceId: String
		$parameters: [ExperimentalCreateAutomationRuleFromTemplateParameter!]
	) @experimental {
		experimentalCreateAutomationRuleFromTemplate(
			templateId: $templateId
			cloudId: $cloudId
			automationStack: $automationStack
			spaceId: $spaceId
			parameters: $parameters
		) {
			ruleId
			ruleUuid
		}
	}
`;
